module.exports = __webpack_public_path__ + "img/priscilla.e77de8ac.jpg";